class BarrierProductDetails extends HTMLElement {
  connectedCallback() {
    this.items = [...this.querySelectorAll(':scope > details')];
    this.controller = new AbortController();
    const { signal } = this.controller;
    // Also support browsers that do not yet implement exclusive details groups.
    this.items.forEach((item) => item.addEventListener('toggle', () => {
      if (item.open) this.items.forEach((other) => { if (other !== item) other.open = false; });
    }, { signal }));
    this.resizeObserver = new ResizeObserver(([entry]) => {
      if (entry.contentRect.width === this.measuredWidth) return;
      this.measuredWidth = entry.contentRect.width;
      this.measure();
    });
    this.resizeObserver.observe(this);
    document.fonts.ready.then(() => { if (this.isConnected) this.measure(); });
  }

  measure() {
    // Reserve one expanded answer on desktop, keeping the sticky gallery's
    // containing block the same height regardless of which answer is open.
    const measure = document.createElement('div');
    measure.className = 'bw-product-details-measure';
    measure.setAttribute('aria-hidden', 'true');
    measure.inert = true;
    this.items.forEach((item) => {
      const clone = item.cloneNode(true);
      clone.removeAttribute('name');
      clone.removeAttribute('id');
      clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
      clone.open = true;
      measure.append(clone);
    });
    this.append(measure);
    const closedHeight = this.items.reduce((height, item) => {
      const style = getComputedStyle(item);
      return height + item.querySelector('summary').getBoundingClientRect().height
        + parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
    }, 0);
    const answerHeight = Math.max(0, ...[...measure.querySelectorAll('.bw-product-detail-copy')]
      .map((copy) => copy.getBoundingClientRect().height));
    this.style.setProperty('--bw-details-height', `${Math.ceil(closedHeight + answerHeight)}px`);
    measure.remove();
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.resizeObserver?.disconnect();
  }
}

if (!customElements.get('barrier-product-details')) customElements.define('barrier-product-details', BarrierProductDetails);
